import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=dbe9f83a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./EditVideo.vue?vue&type=script&lang=js&"
export * from "./EditVideo.vue?vue&type=script&lang=js&"
import style0 from "./EditVideo.vue?vue&type=style&index=0&id=dbe9f83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe9f83a",
  null
  
)

export default component.exports